/**
 * Created by galweissman on 03/11/2015.
 */
import IService from '../IService';

export default IService.extend({
  validateTask_POST: function (data) {
    const promise = new $.Deferred();
    console.log('+ VALIDATE TASK BEGIN <', data.event, '>');
    $.ajax({
      url: app.apiUrl('/task/stories'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),

      error: (jqXHR) => {
        if (jqXHR.status === 404) {
          promise.reject();
          app.dialog.error({
            type: app.dialog.types.ERROR_1,
            title: app.culture.makeCopyMissingVideoModal.title,
            description: app.culture.makeCopyMissingVideoModal.description,
            showContactCsm: false,
          });
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(promise.reject);
        }
      },

      dataType: 'json',
      success: (response) => {
        if (_.isPlainObject(response)) {
          switch (response.response) {
            case 'OK':
              console.log('\t- VALIDATE TASK SUCCESS <', data.event, '>');
              promise.resolve(response);
              break;
            case 'FAILED_VALIDATE_CUSTOM_OVERLAYS':
              promise.reject({ invalidCustomOverlays: true });
              break;
            default:
              console.log('\t-  VALIDATE TASK FAILED <', data.event, '>');
              app.dialog.serverError(response).then(promise.reject);
              break;
          }
        } else {
          console.log('\t- VALIDATE TASK FAILED <', data.event, '>');
          app.dialog.serverError(response).then(promise.reject);
        }
      },
    });
    return promise;
  },

  _getUrl: function (data) {
    const newStory =
      _.isNull(data.id) || data.taskType === app.ROLES.STORY_CREATION;
    return app.apiUrl(newStory ? '/task/stories' : '/task/handleTask');
  },

  post: function (data, options) {
    if (this.mutex) {
      return this.mutex.synchronize(this._ajax.bind(this, data, options));
    } else {
      return this._ajax(data, options);
    }
  },

  _ajax: function (data, options) {
    options = $.extend(
      {
        showError: true,
      },
      options
    );

    const promise = new $.Deferred();
    console.log('+ HANDLETASK BEGIN <', data.event, '>');

    $.ajax({
      url: this._getUrl(data),
      type: 'POST',

      contentType: 'application/json',
      data: JSON.stringify(data),

      error: (jqXHR, textStatus, errorThrown) => {
        if (
          options.showError &&
          !(jqXHR.status === 401 || 'abort' === errorThrown)
        ) {
          app.dialog.serverError(this.createError(jqXHR)).then(promise.reject);
        } else {
          promise.reject(this.createError(jqXHR));
        }
      },

      dataType: 'json',
      success: (response) => {
        if (_.isPlainObject(response)) {
          switch (response.response) {
            case 'OK':
              console.log('\t- HANDLETASK SUCCESS <', data.event, '>');
              promise.resolve(response);
              break;
            case 'VIDEO_ALREADY_MARKED_VIEW':
              console.log('\t- HANDLETASK SUCCESS <', data.event, '>');
              promise.resolve(response);
              break;
            default:
              console.log('\t- HANDLETASK FAILED <', data.event, '>');
              app.dialog.serverError(response).then(promise.reject);
              break;
          }
        } else {
          console.log('\t- HANDLETASK FAILED <', data.event, '>');
          app.dialog.serverError(response).then(promise.reject);
        }
      },
    });

    return promise;
  },
});
